import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Collection1k04j3hzsbod0 as Collection,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from './MutableCollections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableCollectionClass;
function AbstractMutableCollection() {
  if (AbstractMutableCollectionClass === VOID) {
    class $ extends AbstractCollection() {
      static new_kotlin_collections_AbstractMutableCollection_jgoj1k_k$() {
        return this.new_kotlin_collections_AbstractCollection_s1tlv0_k$();
      }
      remove_cedx0m_k$(element) {
        this.checkIsMutable_jn1ih0_k$();
        var iterator = this.iterator_jk1svi_k$();
        while (iterator.hasNext_bitz1p_k$()) {
          if (equals(iterator.next_20eer_k$(), element)) {
            iterator.remove_ldkf9o_k$();
            return true;
          }
        }
        return false;
      }
      addAll_4lah1e_k$(elements) {
        this.checkIsMutable_jn1ih0_k$();
        var modified = false;
        var _iterator__ex2g4s = elements.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (this.add_utx5q5_k$(element))
            modified = true;
        }
        return modified;
      }
      removeAll_y0z8ch_k$(elements) {
        this.checkIsMutable_jn1ih0_k$();
        var tmp = isInterface(this, MutableIterable()) ? this : THROW_CCE();
        return removeAll(tmp, (it) => elements.contains_aljjnj_k$(it));
      }
      toJSON() {
        return this.toArray();
      }
      checkIsMutable_jn1ih0_k$() {
      }
    }
    initMetadataForClass($, 'AbstractMutableCollection', VOID, VOID, [Collection(), MutableIterable()]);
    AbstractMutableCollectionClass = $;
  }
  return AbstractMutableCollectionClass;
}
//region block: exports
export {
  AbstractMutableCollection as AbstractMutableCollections0bg6c40ztuj,
};
//endregion

//# sourceMappingURL=AbstractMutableCollectionJs.mjs.map
